import IHcLocalizerOptions from './interfaces/IHcLocalizerOptions';
import ICultureSets from './interfaces/ICultureSets';
import ITranslations from './interfaces/ITranslations';
import CultureSets from './CultureSets';

export default class HcLocalizer {

    private cultureSets: ICultureSets = new CultureSets();
    private currentCulture!: string;

    private get currentTranslations(): ITranslations {
        return this.cultureSets.getTranslations(this.currentCulture);
    }

    constructor(options?: IHcLocalizerOptions) {
        !!options && this.addOptions(options);
    }

    public addOptions(options: IHcLocalizerOptions): void {
        !!options.defaultCulture
            && options.translations
            && this.addTranslations(options.defaultCulture, options.translations);
        !!options.cultureSets && this.addCultureSets(options.cultureSets);
        !!options.defaultCulture && this.setCurrentCulture(options.defaultCulture);
    }

    public addTranslations(culture: string, translations: { [key: string]: string }): void {
        this.cultureSets.addTranslations(culture, translations);
        let theTranslations = this.cultureSets.getTranslations(culture);
        theTranslations.resolveTranslationReferences();
        theTranslations.htmlizeTranslations();
    }

    public addCultureSets(cultureSets: { [culture: string]: { [key: string]: string } }): void {
        Object.keys(cultureSets).forEach((culture) =>
            this.addTranslations(culture, cultureSets[culture])
        );
    }

    public setCurrentCulture(culture: string): void {
        if(!this.cultureSets.hasCulture(culture))
            throw new Error(`The localizer does not contain culture ${culture}.`);

        this.currentCulture = culture;
    }

    public getTranslation(key: string, ...parameters: any[]): string {
        return this.currentTranslations.getTranslation(key, ...parameters);
    }
}
